import React from 'react';

import { Box } from '@mui/material';

export const MVCPageRedirection = ({ redirectUrl }: { redirectUrl: string }): JSX.Element => {
  window.location.href = redirectUrl;

  return <Box />;
};
